import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref } from 'vue';
import { useTenantStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import AddRSMFile from '@/components/UploadModal/AddRSMFile.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadRSM',
  setup(__props) {

const tenantStore = useTenantStore();
const { loading } = storeToRefs(tenantStore);

const toast = useToast();

const viewModal = ref(false);

const changeViewModal = () => (viewModal.value = !viewModal.value);

const modalCancel = () => {
  viewModal.value = false;
};

const onSave = () => {
  viewModal.value = false;
  doToast();
};

const onError = () => {
  doToast(true);
};

const doToast = (isError?: boolean | string) => {
  toast.add({
    severity: isError ? 'error' : 'success',
    summary: isError ? 'Error' : 'Success',
    detail: isError
      ? 'File not accepted. Please check file and try again'
      : 'File Accepted. Check RSM Activity in Insight Activity Log for Status',
    life: 5000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "flex flex-column" }, [
        _createElementVNode("h2", { class: "m-0" }, "RSM Sync")
      ], -1)
    ]))]),
    content: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "primary",
        text: "Upload File",
        onClick: changeViewModal
      }),
      (viewModal.value)
        ? (_openBlock(), _createBlock(AddRSMFile, {
            key: 0,
            title: "Upload RSM File",
            loading: _unref(loading),
            onCancel: modalCancel,
            onSave: onSave,
            onError: onError
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})